/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateTeamBodyDescriptionOneMax = 2000;

export const updateTeamBodyExpectedVersionExclusiveMin = 0;
export const updateTeamBodyExpectedVersionMax = 9007199254740991;

export const UpdateTeamBody = zod.object({
  name: zod.string().optional(),
  description: zod
    .union([zod.string().max(updateTeamBodyDescriptionOneMax), zod.null()])
    .optional(),
  active: zod.boolean().optional(),
  expectedVersion: zod
    .int()
    .gt(updateTeamBodyExpectedVersionExclusiveMin)
    .max(updateTeamBodyExpectedVersionMax),
});

export type UpdateTeamBody = zod.input<typeof UpdateTeamBody>;
export type UpdateTeamBodyOutput = zod.output<typeof UpdateTeamBody>;
